import { FunctionComponent } from 'react';
import styles from './MedicalSchedule.module.scss';
import { Moment } from 'moment-timezone';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup';
import DailySchedule from './DailySchedule';
import SpecificSchedule from './SpecificSchedule';
import clsx from 'clsx';

interface MedicalScheduleProps {
    from?: Moment | undefined;
    to?: Moment | undefined;
    medicationType: string;
    schedule: Array<string>;
    specificSchedule: Array<DaySchedule>;
    flow: 'boarding' | 'daycare';
    onUpdate: (schedule: Array<string>) => void;
    onUpdateSpecific: (schedule: Array<DaySchedule>) => void;
    onSetMedicationType: (type: string) => void;
    onHasAlerts?: (hasAlerts: boolean) => void;
}

export interface DaySchedule {
    date: Moment;
    enabled: boolean;
    doses: string[];
}

const options = [
    {
        value: 'daily',
        inlineLabel: 'Daily'
    },
    {
        value: 'specific',
        inlineLabel: 'Specific Days'
    }
];

const MedicalSchedule: FunctionComponent<MedicalScheduleProps> = ({
    medicationType,
    from,
    to,
    schedule,
    specificSchedule,
    flow,
    onUpdate,
    onUpdateSpecific,
    onSetMedicationType,
    onHasAlerts
}) => {
    return (
        <div>
            <label className={clsx(styles.label, { [styles.title]: flow === 'daycare' })}>Medical Schedule</label>

            <div className={styles.doseSchedule}>
                {flow === 'boarding' && (
                    <RadioGroup
                        value={medicationType}
                        options={options}
                        className={styles.radioGroup}
                        onChange={onSetMedicationType}
                    />
                )}

                {medicationType === 'specific' && flow === 'boarding' ? (
                    <div className={flow === 'boarding' ? styles.specificSchedule : undefined}>
                        <SpecificSchedule
                            from={from}
                            to={to}
                            schedule={specificSchedule}
                            onUpdate={onUpdateSpecific}
                            onHasAlerts={onHasAlerts}
                        />
                    </div>
                ) : (
                    <div className={flow === 'boarding' ? styles.dailySchedule : undefined}>
                        <DailySchedule
                            from={from}
                            to={to}
                            schedule={schedule}
                            onUpdate={onUpdate}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default MedicalSchedule;
